import { slicedToArray as _slicedToArray } from '../../_virtual/_rollupPluginBabelHelpers.js';
import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { Text, Spinner, Paragraph, Box } from '@zillow/constellation';
import { fetchRatesArticle } from './MortgageRatesSummary.utils.js';
import { PAGE_FLAVOR_LOAN_TYPE_MAP, LOAN_TYPES } from '../../utils/mortgagehelpers/constants.js';
import MortgagePageClassification from '../../utils/mortgagehelpers/MortgagePageClassification.js';
import { RatesArticle } from './RateArticle.js';
import LegalDisclosuresModal from '../LegalDisclosuresModal/LegalDisclosuresModal.js';
import { setServerUrl } from '../../utils/mortgagehelpers/mortgage-helpers.js';
import { getMortgageRates } from '../LegalDisclosuresModal/constants.js';

var MortgageRatesSummary = function MortgageRatesSummary(_ref) {
  var pathname = _ref.pathname;
  var classification = new MortgagePageClassification(pathname ? pathname : '/mortgage-rates/');
  var _useState = useState(null),
    _useState2 = _slicedToArray(_useState, 2),
    article = _useState2[0],
    setArticle = _useState2[1];
  var _useState3 = useState(true),
    _useState4 = _slicedToArray(_useState3, 2),
    loading = _useState4[0],
    setLoading = _useState4[1];
  var _useState5 = useState({}),
    _useState6 = _slicedToArray(_useState5, 2),
    rates = _useState6[0],
    setRates = _useState6[1];
  var _useState7 = useState(false),
    _useState8 = _slicedToArray(_useState7, 2),
    error = _useState8[0],
    setError = _useState8[1];
  useEffect(function () {
    setServerUrl();
  }, []);
  useEffect(function () {
    var _PAGE_FLAVOR_LOAN_TYP;
    fetchRatesArticle({
      refinance: classification.refinance,
      stateAbbreviation: classification.stateAbbreviation,
      loanType: (_PAGE_FLAVOR_LOAN_TYP = PAGE_FLAVOR_LOAN_TYPE_MAP[classification.flavor]) !== null && _PAGE_FLAVOR_LOAN_TYP !== void 0 ? _PAGE_FLAVOR_LOAN_TYP : LOAN_TYPES.Conventional,
      program: 'Fixed30Year'
    }).then(function (response) {
      if (response.hasApiError) {
        setError(true);
        setLoading(false);
      } else {
        setArticle(response);
        setLoading(false);
      }
    });
  }, []);
  useEffect(function () {
    var fetchRates = function fetchRates() {
      return new Promise(function ($return, $error) {
        var response;
        var $Try_1_Post = function () {
          try {
            return $return();
          } catch ($boundEx) {
            return $error($boundEx);
          }
        };
        var $Try_1_Catch = function (error) {
          try {
            console.error('Error fetching mortgage rates:', error);
            return $Try_1_Post();
          } catch ($boundEx) {
            return $error($boundEx);
          }
        };
        try {
          return Promise.resolve(getMortgageRates(pathname)).then(function ($await_2) {
            try {
              response = $await_2;
              setRates(response);
              return $Try_1_Post();
            } catch ($boundEx) {
              return $Try_1_Catch($boundEx);
            }
          }, $Try_1_Catch);
        } catch (error) {
          $Try_1_Catch(error);
        }
      });
    };
    fetchRates();
  }, [pathname]);
  if (loading) {
    return /*#__PURE__*/React.createElement(Text, null, /*#__PURE__*/React.createElement(Spinner, null), " Loading...");
  } else if (error) {
    return /*#__PURE__*/React.createElement(Paragraph, null, "An error occurred, please try again later.");
  } else {
    return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(RatesArticle, {
      article: article
    }), /*#__PURE__*/React.createElement(Box, {
      sx: {
        marginTop: '$spacing.sm'
      }
    }, /*#__PURE__*/React.createElement(LegalDisclosuresModal, {
      classification: classification,
      rates: rates
    })));
  }
};
MortgageRatesSummary.propTypes = process.env.NODE_ENV !== "production" ? {
  pathname: PropTypes.string
} : {};
var MortgageRatesSummary$1 = MortgageRatesSummary;

export { MortgageRatesSummary$1 as default };
